/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { GetEligibleWalletsParams, PaymentWalletDetailsDto, WalletDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class PaymentWalletController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags payment-wallet-controller
   * @name GetEligibleWallets
   * @request GET:/api/v1/payments/wallets
   */
  getEligibleWallets = (query: GetEligibleWalletsParams, params: RequestParams = {}) =>
    this.http.request<WalletDto[], any>({
      path: `/v1/payments/wallets`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getEligibleWalletsPath = '/v1/payments/wallets'
  static getEligibleWalletsMethod = 'GET'
  /**
   * No description
   *
   * @tags payment-wallet-controller
   * @name GetPaymentWalletDetails
   * @request GET:/api/v1/payments/wallets/{walletId}/details
   */
  getPaymentWalletDetails = (walletId: string, params: RequestParams = {}) =>
    this.http.request<PaymentWalletDetailsDto, any>({
      path: `/v1/payments/wallets/${walletId}/details`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPaymentWalletDetailsPath = '/v1/payments/wallets/${walletId}/details'
  static getPaymentWalletDetailsMethod = 'GET'
}
